import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { map } from 'lodash-es';

import { PageWrapper } from 'components-antd';
import { MainPageCard } from 'components';
import { Icons } from './Icons';
import { routes } from 'settings/navigation/routes';
import workshopBgImg from 'images/workshop-bg.png';

import styles from './styles.module.scss';

export const Workshop = () => {
  const history = useHistory();

  const handleTransactionsClick = () => history.push(routes.transactions);
  const handleProjectsClick = () => history.push(routes.projects);
  const handleTasksClick = () => history.push(routes.tasks);
  const handleOffersClick = () => history.push(routes.offers);
  const handleShowingsClick = () => history.push(routes.showings);
  const handleFormsClick = () => history.push(routes.workshopForms);

  return (
    <PageWrapper version={2} mainPageContentStyle={styles.mainPageContent}>
      <p className={styles.heading}>Workshop</p>
      <img src={workshopBgImg} className={styles.bgImage} alt="" />
      <div className={classNames(styles.content)}>
        <div className={classNames(styles.cardsContainer)}>
          {map(
            [
              { icon: Icons.TRANSACTIONS, title: 'Transactions', onClick: handleTransactionsClick },
              { icon: Icons.PROJECTS, title: 'Projects', onClick: handleProjectsClick },
              { icon: Icons.TASKS, title: 'Tasks', onClick: handleTasksClick },
              { icon: Icons.OFFERS, title: 'Offers', onClick: handleOffersClick },
              { icon: Icons.SHOWINGS, title: 'Showings', onClick: handleShowingsClick },
              { icon: Icons.FORMS, title: 'Forms', onClick: handleFormsClick },
            ],
            ({ icon, title, onClick }, idx) => (
              <MainPageCard
                key={idx}
                onClick={onClick}
                icon={<Icons variant={icon} />}
                title={title}
              />
            ),
          )}
        </div>
      </div>
    </PageWrapper>
  );
};
